<template>
  <div :key="key" class="animated fadeIn position-relative">
    <loader v-if="loading" />

    <div class="resource-settings-container d-flex justify-content-end">
      <b-btn to="dashboard/settings" variant="outline-primary" class="resource-settings-button">
        <i class="icon-settings mr-sm-2"></i>
        <span class="resource-settings-button__title">{{ $t('dashboard.settings') }}</span>
      </b-btn>
    </div>
    <b-row>
      <b-col>
        <b-row>
          <b-col>
            <b-card v-if="!loading && showStats.total_revenue" class="white-container total-revenue-section bordered-cells-statistics-section">
              <b-row>
                <b-col>
                  <h4 id="total-revenue" class="card-title mb-3">
                    {{ $t('dashboard.total_revenue') }}
                  </h4>
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <b-row>
                    <b-col  class="mb-4">
                      <Callout variant="info" class="h-100 m-0">
                        <small class="text-title mr-2">{{ $t('dashboard.last_week') }}
                          <custom-tooltip :name="$t('dashboard.last_week')">
                            {{ $t('dashboard.tooltips.last_7_days') }}
                          </custom-tooltip>
                        </small>
                        <br />
                        <strong class="h7 value"
                          >{{ $t('global.usd') }}{{ formatAmount(statistics.last_week) }}</strong
                        >
                      </Callout>
                    </b-col>
                    <b-col  class="mb-4">
                      <Callout variant="info" class="h-100 m-0">
                        <small class="text-title mr-2">{{ $t('dashboard.last_month') }}
                          <custom-tooltip :name="$t('dashboard.last_month')">
                            {{ $t('dashboard.tooltips.last_31_days') }}
                          </custom-tooltip>
                        </small>
                        <br />
                        <strong class="h7 value"
                          >{{ $t('global.usd') }}{{ formatAmount(statistics.last_month) }}</strong
                        >
                      </Callout>
                    </b-col>
                    <b-col  class="mb-4">
                      <Callout variant="info" class="h-100 m-0">
                        <small class="text-title mr-2">{{ $t('dashboard.this_month') }} ({{ getThisMonth() }})
                          <custom-tooltip :name="$t('dashboard.this_month')">
                            {{ $t('dashboard.tooltips.month_to_date') }}
                          </custom-tooltip>
                        </small>
                        <br />
                        <strong class="h7 value"
                          >{{ $t('global.usd') }}{{ formatAmount(statistics.this_month) }}</strong
                        >
                      </Callout>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col  class="mb-4">
                      <Callout variant="info" class="h-100 m-0">
                        <small class="text-title mr-2">{{ $t('dashboard.prev_month') }} ({{ getLastMonth() }})
                          <custom-tooltip :name="$t('dashboard.prev_month')">
                            {{ $t('dashboard.tooltips.last_month') }}
                          </custom-tooltip>
                        </small>
                        <br />
                        <strong class="h7 value"
                        >{{ $t('global.usd') }}{{ formatAmount(statistics.prev_month) }}</strong
                        >
                      </Callout>
                    </b-col>
                    <b-col  class="mb-4">
                      <Callout variant="info" class="h-100 m-0">
                        <small class="text-title mr-2">{{ $t('dashboard.this_year') }}
                          <custom-tooltip :name="$t('dashboard.this_year')">
                            {{ $t('dashboard.tooltips.year_to_date') }}
                          </custom-tooltip>
                        </small>
                        <br />
                        <strong class="h7 value"
                        >{{ $t('global.usd') }}{{ formatAmount(statistics.this_year) }}</strong
                        >
                      </Callout>
                    </b-col>
                    <b-col  class="mb-4">
                      <Callout variant="info" class="h-100 m-0">
                        <small class="text-title mr-2">{{ $t('dashboard.last_year') }}
                          <custom-tooltip :name="$t('dashboard.last_year')">
                            {{ $t('dashboard.tooltips.last_365_days') }}
                          </custom-tooltip>
                        </small>
                        <br />
                        <strong class="h7 value">{{ $t('global.usd') }}{{ formatAmount(statistics.last_year) }}</strong>
                      </Callout>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
            </b-card>

            <b-card v-if="!loading && showStats.subscribers_statistics" class="white-container subscribers-statistics-section bordered-cells-statistics-section">
              <b-row>
                <b-col>
                  <h4 id="subscriber-statistics" class="card-title mb-3">
                    {{ $t('dashboard.subscribers_statistics') }}
                  </h4>
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <b-row>
                    <b-col class="mb-4">
                      <Callout variant="info" class="h-100 m-0">
                        <small class="text-title">{{
                          $t('dashboard.new_single_subscriptions_this_month')
                        }}</small>
                        <br />
                        <strong class="h7 value">{{
                          statistics.new_single_subscriptions_this_month
                        }}</strong>
                        <b-btn
                          variant="link"
                          v-if="!!statistics.new_single_subscriptions_this_month"
                          class="px-1"
                          style="margin-bottom: 2px"
                          @click="
                            userTablesOptions.new_single_subscriptions_this_month.show =
                              !userTablesOptions.new_single_subscriptions_this_month.show;
                            manageUserTable(
                              userTablesOptions.new_single_subscriptions_this_month,
                              userTablesOptions.new_single_subscriptions_this_month.show,
                            );
                          "
                        >
                          <small class="text-lowercase"
                            >({{
                              userTablesOptions.new_single_subscriptions_this_month.show
                                ? $t('dashboard.hide')
                                : $t('global.list')
                            }})</small
                          >
                        </b-btn>
                      </Callout>
                    </b-col>
                    <b-col class="mb-4">
                      <Callout variant="info" class="h-100 m-0">
                        <small class="text-title">{{
                          $t('dashboard.new_team_subscriptions_this_month')
                        }}</small>
                        <br />
                        <strong class="h7 value">{{
                          statistics.new_team_subscriptions_this_month
                        }}</strong>
                        <b-btn
                          variant="link"
                          v-if="!!statistics.new_team_subscriptions_this_month"
                          class="px-1"
                          style="margin-bottom: 2px"
                          @click="
                            userTablesOptions.new_team_subscriptions_this_month.show =
                              !userTablesOptions.new_team_subscriptions_this_month.show;
                            manageUserTable(
                              userTablesOptions.new_team_subscriptions_this_month,
                              userTablesOptions.new_team_subscriptions_this_month.show,
                            );
                          "
                        >
                          <small class="text-lowercase"
                            >({{
                              userTablesOptions.new_team_subscriptions_this_month.show
                                ? $t('dashboard.hide')
                                : $t('global.list')
                            }})</small
                          >
                        </b-btn>
                      </Callout>
                    </b-col>
                    <b-col class="mb-4">
                      <Callout variant="info" class="h-100 m-0">
                        <small class="text-title">{{
                          $t('dashboard.downgrading_paid_member_this_month')
                        }}
                          <custom-tooltip class="ml-2" :name="$t('dashboard.renewing_this_month')">
                            {{ $t('dashboard.tooltips.paid_expiring_this_month') }}
                          </custom-tooltip>
                        </small>
                        <br />
                        <strong class="h7 value">{{
                          statistics.downgrading_paid_member_this_month
                        }}</strong>
                        <b-btn
                          variant="link"
                          v-if="!!statistics.downgrading_paid_member_this_month"
                          class="px-1"
                          style="margin-bottom: 2px"
                          @click="
                            userTablesOptions.downgrading_paid_member_this_month.show =
                              !userTablesOptions.downgrading_paid_member_this_month.show;
                            manageUserTable(
                              userTablesOptions.downgrading_paid_member_this_month,
                              userTablesOptions.downgrading_paid_member_this_month.show,
                            );
                          "
                        >
                          <small class="text-lowercase"
                            >({{
                              userTablesOptions.downgrading_paid_member_this_month.show
                                ? $t('dashboard.hide')
                                : $t('global.list')
                            }})</small
                          >
                        </b-btn>
                      </Callout>
                    </b-col>
                    <b-col class="mb-4">
                      <Callout variant="info" class="h-100 m-0">
                        <small class="text-title">{{ $t('dashboard.renewing_this_month') }}</small>
                        <br />
                        <strong class="h7 value">{{ statistics.renewing_this_month }}</strong>
                        <b-btn
                          variant="link"
                          v-if="!!statistics.renewing_this_month"
                          class="px-1"
                          style="margin-bottom: 2px"
                          @click="
                            userTablesOptions.renewing_this_month.show =
                              !userTablesOptions.renewing_this_month.show;
                            manageUserTable(
                              userTablesOptions.renewing_this_month,
                              userTablesOptions.renewing_this_month.show,
                            );
                          "
                        >
                          <small class="text-lowercase"
                            >({{
                              userTablesOptions.renewing_this_month.show
                                ? $t('dashboard.hide')
                                : $t('global.list')
                            }})</small
                          >
                        </b-btn>
                      </Callout>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col class="mb-4">
                      <Callout variant="info" class="h-100 m-0">
                        <small class="text-title">{{ $t('dashboard.past_due_users') }}
                          <custom-tooltip class="ml-2" :name="$t('dashboard.past_due_users')">
                            {{ $t('dashboard.tooltips.past_due') }}
                          </custom-tooltip>
                        </small>
                        <br />
                        <strong class="h7 value">{{ statistics.past_due_users }}</strong>
                        <b-btn
                          variant="link"
                          v-if="!!statistics.past_due_users"
                          class="px-1"
                          style="margin-bottom: 2px"
                          @click="
                            userTablesOptions.past_due_users.show =
                              !userTablesOptions.past_due_users.show;
                            manageUserTable(
                              userTablesOptions.past_due_users,
                              userTablesOptions.past_due_users.show,
                            );
                          "
                        >
                          <small class="text-lowercase"
                            >({{
                              userTablesOptions.past_due_users.show
                                ? $t('dashboard.hide')
                                : $t('global.list')
                            }})</small
                          >
                        </b-btn>
                      </Callout>
                    </b-col>
                    <b-col class="mb-4">
                      <Callout variant="info" class="h-100 m-0">
                        <small class="text-title">{{ $t('dashboard.churn_w_w') }}
                          <custom-tooltip class="ml-2" :name="$t('dashboard.churn_w_w')">
                            {{ $t('dashboard.tooltips.churn_w_w') }}
                          </custom-tooltip>
                        </small>
                        <br />
                        <strong class="h7 value">{{ churnWW || 0 }}</strong>
                        <b-btn
                          variant="link"
                          v-if="!!churnWW"
                          class="px-1"
                          style="margin-bottom: 2px"
                          @click="
                            userTablesOptions['churnWW'].show = !userTablesOptions['churnWW'].show;
                            manageUserTable(
                              userTablesOptions['churnWW'],
                              userTablesOptions['churnWW'].show,
                            );
                          "
                        >
                          <small class="text-lowercase"
                            >({{
                              userTablesOptions['churnWW'].show
                                ? $t('dashboard.hide')
                                : $t('global.list')
                            }})</small
                          >
                        </b-btn>
                      </Callout>
                    </b-col>
                    <b-col class="mb-4">
                      <Callout variant="info" class="h-100 m-0">
                        <small class="text-title">{{ $t('dashboard.churn_m_m') }}
                          <custom-tooltip class="ml-2" :name="$t('dashboard.churn_m_m')">
                            {{ $t('dashboard.tooltips.churn_m_m') }}
                          </custom-tooltip>
                        </small>
                        <br />
                        <strong class="h7 value">{{ churnMM || 0 }}</strong>
                        <b-btn
                          variant="link"
                          v-if="!!churnMM"
                          class="px-1"
                          style="margin-bottom: 2px"
                          @click="
                            userTablesOptions['churnMM'].show = !userTablesOptions['churnMM'].show;
                            manageUserTable(
                              userTablesOptions['churnMM'],
                              userTablesOptions['churnMM'].show,
                            );
                          "
                        >
                          <small class="text-lowercase"
                            >({{
                              userTablesOptions['churnMM'].show
                                ? $t('dashboard.hide')
                                : $t('global.list')
                            }})</small
                          >
                        </b-btn>
                      </Callout>
                    </b-col>
                    <b-col class="mb-4">
                      <Callout variant="info" class="h-100 m-0">
                        <small class="text-title">{{ $t('dashboard.churn_y_y') }}
                          <custom-tooltip class="ml-2" :name="$t('dashboard.churn_y_y')">
                            {{ $t('dashboard.tooltips.churn_y_y') }}
                          </custom-tooltip>
                        </small>
                        <br />
                        <strong class="h7 value">{{ churnYY || 0 }}</strong>
                        <b-btn
                          variant="link"
                          v-if="!!churnYY"
                          class="px-1"
                          style="margin-bottom: 2px"
                          @click="
                            userTablesOptions['churnYY'].show = !userTablesOptions['churnYY'].show;
                            manageUserTable(
                              userTablesOptions['churnYY'],
                              userTablesOptions['churnYY'].show,
                            );
                          "
                        >
                          <small class="text-lowercase"
                            >({{
                              userTablesOptions['churnYY'].show
                                ? $t('dashboard.hide')
                                : $t('global.list')
                            }})</small
                          >
                        </b-btn>
                      </Callout>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
            </b-card>

            <b-col lg="12" v-for="item in userTables" :key="item.index" class="p-0">
              <UsersTableOnCard
                :url="item.url"
                :columns="columns[item.columnsType]"
                :options="options"
                @loaded="item.loading = false"
                @loading="item.loading = true"
                :loading="item.loading"
                :enable-export="item.enableExport"
                :export-request="item.exportRequest"
                :params="item.params"
                :title="item.title"
              />
            </b-col>
          </b-col>
        </b-row>

        <!-- Advanced statistics -->
        <b-row v-if="!loading && showStats.advanced_statistic">
          <b-col lg="12" class="overview-filter">
            <PeriodSelector @input="updateStatistics" />
          </b-col>
        </b-row>

        <b-row v-if="!loading && showStats.advanced_statistic">
          <b-col v-for="card in statisticCards" :key="card.id" lg="4">
            <b-overlay
              :show="loading_statistics"
              rounded="10"
              opacity="0.7"
              spinner-variant="primary"
            >
              <StatisticsCard
                :title="card.title"
                :tooltip-name="card.tooltipName"
                :tooltip-text="card.tooltipText"
                :data="getChartData(card.id)"
                :is-currency="card.isCurrency"
                :item-value-decorator="card.itemValueDecorator"
                :current-value-decorator="card.currentValueDecorator"
                :compared-value-decorator="card.comparedValueDecorator"
                :group-by="groupBy"
              />
            </b-overlay>
          </b-col>
        </b-row>
        <!-- End Advanced statistics -->

        <b-row>
          <b-col lg="6" v-if="!!planUsers.length && showStats.members_by_plan">
            <b-card class="white-container">
              <b-row>
                <b-col>
                  <h4 id="members-by-plan" class="card-title mb-4">
                    {{ $t('dashboard.members_by_plan') }}
                  </h4>
                </b-col>
              </b-row>
              <chart-doughtnut :data="planUsers" :labels="planLabels" />
            </b-card>
          </b-col>
          <b-col lg="6" v-if="!!totalActiveSubscribers.length && showStats.members_by_plan">
            <b-card v-if="totalActiveSubscribers.length" class="white-container">
              <b-row>
                <b-col>
                  <h4 id="total-active-subscribers" class="card-title mb-4">
                    {{ $t('dashboard.total_active_subscribers') }}
                  </h4>
                </b-col>
              </b-row>
              <chart-bar :data="totalActiveSubscribers" :labels="totalActiveSubscribersLabels" />
            </b-card>
          </b-col>
          <b-col>
            <b-card v-if="!!memberData.length && showStats.members_signups" class="white-container">
              <b-row class="align-items-end">
                <b-col>
                  <h4 id="member_registrations" class="card-title mb-4">
                    {{ $t('dashboard.member_registrations') }}
                  </h4>
                </b-col>
              </b-row>
              <chart-line
                chart-id="main-chart-01"
                :labels="memberLabels"
                :data="memberData"
                :show-ticks="false"
                :titles="usersPlanTitles"
              />
              <div slot="footer">
                <b-row class="text-center align-items-end">
                  <b-col class="mb-sm-2" v-for="(plan, index) in usersPlanTitles" :key="index">
                    <div
                      class="text-muted pb-2"
                      :style="{ borderBottom: `4px solid ${getColorByIndex(index)}` }"
                    >
                      {{ plan }}
                    </div>
                  </b-col>
                </b-row>
              </div>
            </b-card>
          </b-col>
          <b-col v-if="!!revenueData.length && showStats.total_revenue">
            <b-card class="white-container">
              <b-row>
                <b-col>
                  <h4 id="revenue" class="card-title mb-4">
                    {{ $t('dashboard.revenue_by_month') }}
                  </h4>
                </b-col>
              </b-row>
              <chart-line
                chartId="main-chart-01"
                :labels="revenueLabels"
                :data="revenueData"
                :format="true"
                :titles="[
                  $t('dashboard.subscription'),
                  $t('dashboard.content'),
                  $t('dashboard.total'),
                ]"
              >
              </chart-line>
              <div slot="footer" class="text-center">
                <b-row>
                  <b-col
                    md="4"
                    class="mb-sm-2"
                    v-for="(title, index) in membersTitles"
                    :key="index"
                  >
                    <div
                      class="text-muted pb-2"
                      :style="{ borderBottom: `4px solid ${getColorByIndex(index)}` }"
                    >
                      {{ $t(`${title}`) }}
                    </div>
                  </b-col>
                </b-row>
              </div>
            </b-card>
          </b-col>
          <b-col v-if="!!transactionData.length && showStats.transactions_by_month">
            <b-card class="white-container">
              <b-row>
                <b-col>
                  <h4 id="transactions" class="card-title mb-4">
                    {{ $t('dashboard.transactions_by_month') }}
                  </h4>
                </b-col>
              </b-row>
              <chart-line
                chartId="main-chart-01"
                :labels="revenueLabels"
                :data="transactionData"
                :showTicks="false"
                :titles="[
                  $t('dashboard.subscription'),
                  $t('dashboard.content'),
                  $t('dashboard.total'),
                ]"
              >
              </chart-line>
              <div slot="footer">
                <b-row class="text-center">
                  <b-col
                    md="4"
                    class="mb-sm-2"
                    v-for="(title, index) in membersTitles"
                    :key="index"
                  >
                    <div
                      class="text-muted pb-2"
                      :style="{ borderBottom: `4px solid ${getColorByIndex(index)}` }"
                    >
                      {{ $t(`${title}`) }}
                    </div>
                  </b-col>
                </b-row>
              </div>
            </b-card>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import ChartLine from './ChartLine';
import ChartDoughtnut from './ChartDoughtnut';
import { Callout } from '@coreui/vue';
import moment from 'moment';
import ChartBar from './ChartBar';
import i18n from '@/utils/i18n';
import axios from '@/utils/axios';
import UsersTableOnCard from '../../components/global/usersTableOnCard';
import StatisticsCard from './StatisticsCard';
import PeriodSelector from './PeriodSelector';
import statisticCards from './statisticCards';
import { get } from 'lodash';

export default {
  middleware: 'auth',
  name: 'dashboard',
  components: {
    UsersTableOnCard,
    ChartBar,
    ChartLine,
    Callout,
    ChartDoughtnut,
    StatisticsCard,
    PeriodSelector,
  },
  data: function () {
    return {
      data: {},
      loading: false,
      loading_statistics: false,
      memberLabels: [],
      membersTitles: ['dashboard.subscription', 'dashboard.content', 'dashboard.total'],
      usersPlanTitles: [],
      memberData: [],
      revenueLabels: [],
      transactionData: [],
      revenueData: [],
      statistics: {},
      planLabels: [],
      planUsers: [],
      showStats: {},
      totalActiveSubscribers: [],
      totalActiveSubscribersLabels: [
        `${this.$t('dashboard.paid_plans')}`,
        `${this.$t('dashboard.free_plans')}`,
      ],
      showPastDueUsers: false,
      showChurnWW: false,
      showChurnMM: false,
      showChurnYY: false,
      columns: {
        past_due: [
          'id',
          'full_name',
          'email',
          'location',
          'created_at',
          'subscriptions',
          'renewal_date',
          'actions',
        ],
        churn: [
          'full_name_and_email',
          'date_changed',
          'subscription_end_date',
          'ltv',
          'last_transaction',
          'current_subscription',
          'previous_subscription',
          'actions',
        ],
      },
      options: {
        skin: [],
        headings: {
          id: '#',
          full_name: i18n.t('users.full_name'),
          email: i18n.t('users.email'),
          location: i18n.t('users.location'),
          created_at: i18n.t('form.created_at'),
          subscriptions: i18n.t('users.subscription_info'),
          current_subscription: i18n.t('users.current_subscription'),
          previous_subscription: i18n.t('users.previous_subscription'),
          renewal_date: i18n.t('form.renewal_date'),
          actions: i18n.t('global.actions'),
          date_changed: i18n.t('dashboard.date_changed'),
          subscription_end_date: i18n.t('dashboard.subscription_end_date'),
          last_transaction: i18n.t('dashboard.last_transaction'),
          ltv: i18n.t('dashboard.ltv'),
          full_name_and_email: i18n.t('dashboard.user'),
        },
        filterable: false,
        requestFunction: function (data) {
          let params = {};
          params.limit = data.limit;
          params.filter = data.custom;
          params.page = data.page;
          localStorage.setItem('perPagePastDue', data.limit);
          // if (params.filter['userresourcerelationships.suspended'] === undefined) {
          //   params.filter['userresourcerelationships.suspended'] = false
          // }
          return axios
            .get(this.url, {
              params: params,
            })
            .catch((e) => {
              // this.$noty.error(e.error_description);
              this.dispatch('error', e);
            });
        },
        responseAdapter: function (resp) {
          let data = this.getResponseData(resp);
          return {
            data: data.data.items,
            count: data.data.paginator.total_items,
          };
        },
        customFilters: ['custom'],
      },
      userTables: [],
      loadingPastDue: false,
      loadingChurnWW: false,
      loadingChurnMM: false,
      loadingChurnYY: false,
      churnWW: null,
      churnMM: null,
      churnYY: null,
      currentDate: null,
      statisticsParams: null,
      chartData: null,
      statisticCards: statisticCards,
    };
  },
  mounted() {
    this.loading = true;
    this.loading_statistics = true;
    this.currentDate = moment(new Date()).format('YYYY-MM-DD');
    this.getSettings();
    this.getCharts();
  },
  methods: {
    getChartData(path) {
      return get(this.chartData, path, null);
    },
    updateStatistics(value) {
      this.statisticsParams = value;
      this.loadChartData();
    },
    async loadChartData() {
      this.loading_statistics = true;
      try {
        await this.getData('dashboard/statistics', {
          params: this.statisticsParams,
        }).then(({ data }) => {
          this.chartData = data;
        });
      } catch (e) {
        console.log(e);
      } finally {
        this.loading_statistics = false;
      }
    },
    getThisMonthSubscriptionsStart() {
      return {
        start: new moment().date(1).format('L'),
        end: this.getCurrentDate(),
      };
    },
    getThisMonthSubscriptionsEnd() {
      return {
        start: this.getCurrentDate(),
        end: new moment().endOf('month').format('L'),
      };
    },
    getThisMonthPaidExpiring() {
      return {
        start: new moment().startOf('month').format('L'),
        end: new moment().endOf('month').format('L'),
      };
    },
    getThisMonthSubscriptionsRenewing() {
      return {
        start: new moment().date(1).format('L'),
        end: new moment().endOf('month').format('L'),
      };
    },
    getThisMonthSubscriptionsRenewed() {
      return {
        start: new moment().date(1).format('L'),
        end: this.getCurrentDate(),
      };
    },
    getCharts() {
      this.getData(`charts/activity?groupby=month&period=24month`).then(({ data }) => {
        this.usersPlanTitles = Object.keys(data.data[0].users.by_plans);
        const arr = [];
        this.usersPlanTitles.forEach((title) => {
          let planArray = [];
          data.data.forEach((item) => {
            if (item.users && item.users.by_plans) {
              Object.keys(item.users.by_plans).forEach((plan) => {
                if (title === plan) {
                  planArray.push(item.users.by_plans[plan]);
                }
              });
            }
          });
          arr.push(planArray);
        });
        data.data.forEach((item) => {
          this.memberLabels.push(this.formatDate(item.groupby, 'MMMM YYYY'));
        });
        this.memberData = arr;
      });

      this.getData(`charts/activity?groupby=month&period=24month`).then(({ data }) => {
        const subscriptionRevenue = [];
        const contentRevenue = [];
        const subscriptionCount = [];
        const contentCount = [];
        const totalRevenue = [];
        const totalCount = [];
        if (data.data) {
          data.data.forEach((item) => {
            this.revenueLabels.push(this.formatDate(item.groupby, 'MMMM YYYY'));
            if (item.purchases) {
              if (item.purchases.subscription && item.purchases.empty) {
                subscriptionRevenue.push(
                  item.purchases.subscription.revenue + item.purchases.empty.revenue,
                );
                subscriptionCount.push(
                  item.purchases.subscription.count + item.purchases.empty.count,
                );
              } else {
                subscriptionRevenue.push(0);
                subscriptionCount.push(0);
              }
              if (item.purchases.content) {
                contentRevenue.push(item.purchases.content.revenue);
                contentCount.push(item.purchases.content.count);
              } else {
                contentRevenue.push(0);
                contentCount.push(0);
              }
            } else {
              subscriptionRevenue.push(0);
              contentRevenue.push(0);
              subscriptionCount.push(0);
              contentCount.push(0);
            }
            if (item.transactions) {
              totalRevenue.push(item.transactions.revenue);
              totalCount.push(item.transactions.count);
            } else {
              totalRevenue.push(0);
              totalCount.push(0);
            }
          });

          this.revenueData.push(subscriptionRevenue);
          this.revenueData.push(contentRevenue);
          this.revenueData.push(totalRevenue);
          this.transactionData.push(subscriptionCount);
          this.transactionData.push(contentCount);
          this.transactionData.push(totalCount);
        }
      });
      this.getData(`charts/statistic`).then(({ data }) => {
        this.statistics = data.items;
        this.statistics.last_week = data.items.amount_last_week;
        this.statistics.last_month = data.items.amount_last_month;
        this.statistics.this_month = data.items.amount_this_month;
        this.statistics.prev_month = data.items.amount_prev_month;
        this.statistics.this_year = data.items.amount_this_year;
        this.statistics.last_year = data.items.amount_last_year;
        this.$forceUpdate();
        this.loading = false;
      });
      this.getData(`charts/plan-subscriptions`).then(({ data }) => {
        data.items.map((item) => {
          this.planLabels.push(item.plan_title);
          this.planUsers.push(item.count);
        });
      });
      this.getData('charts/total-active-subscribers').then(({ data }) => {
        for (const item in data.items) {
          let totalSubs = 0;
          for (const subscription of data.items[item]) {
            totalSubs += subscription.total_subscribers;
          }
          this.totalActiveSubscribers.push(totalSubs);
        }
      });
      this.getChurnCounts(1, 'week').then((data) => {
        this.churnWW = data;
      });
      this.getChurnCounts(1, 'month').then((data) => {
        this.churnMM = data;
      });
      this.getChurnCounts(1, 'year').then((data) => {
        this.churnYY = data;
      });
    },
    clearArrays() {
      this.memberLabels = [];
      this.usersPlanTitles = [];
      this.memberData = [];
      this.revenueLabels = [];
      this.transactionData = [];
      this.revenueData = [];
      this.statistics = {};
      this.planLabels = [];
      this.planUsers = [];
      this.totalActiveSubscribers = [];
    },
    getSubtractedDate(amount, time) {
      return moment(this.currentDate, 'YYYY-MM-DD').subtract(amount, time).format('YYYY-MM-DD');
    },
    getChurnQuery(amount, time, adminUrl = true) {
      if (adminUrl) {
        return `/admin/charts/churn-users?date_start=${this.getSubtractedDate(
          amount,
          time,
        )}&date_end=${this.getFormattedEndDate}`;
      }
      return `churn-users?date_start=${this.getSubtractedDate(amount, time)}&date_end=${
        this.getFormattedEndDate
      }`;
    },
    getNewSingleSubscriptionsThisMonthDownloadUrl() {
      const params = {
        order: 'Users.id',
        download: true,
      };

      const filter = {
        'users.active': true,
        paid_subscriptions: true,
        new_paid_subscribers_from: this.getThisMonthSubscriptionsStart().start,
        'userplanrelationships.is_team_subscription': false,
        'userplanrelationships.created_at': `${this.getThisMonthSubscriptionsStart().start}-${
          this.getThisMonthSubscriptionsStart().end
        }`,
      };

      const queryString = new URLSearchParams(params).toString();
      const filterString = encodeURIComponent(JSON.stringify(filter));
      return `users?${queryString}&filter=${filterString}`;
    },
    getNewTeamSubscriptionsThisMonthDownloadUrl() {
      const params = {
        order: 'Users.id',
        download: true,
      };

      const filter = {
        'users.active': true,
        'teams.count': -1,
        'userplanrelationships.subscription_start_date': `${
          this.getThisMonthSubscriptionsStart().start
        }-${this.getThisMonthSubscriptionsStart().end}`,
      };

      const queryString = new URLSearchParams(params).toString();
      const filterString = encodeURIComponent(JSON.stringify(filter));
      return `users?${queryString}&filter=${filterString}`;
    },
    getDowngradingPaidMemberThisMonthDownloadUrl() {
      const params = {
        order: 'Users.id',
        download: true,
      };

      const filter = {
        'users.active': true,
        paid_subscriptions: 1,
        'userplanrelationships.autorenew': false,
        'userplanrelationships.subscription_end_date': `${this.getThisMonthPaidExpiring().start}-${
          this.getThisMonthPaidExpiring().end
        }`,
      };

      const queryString = new URLSearchParams(params).toString();
      const filterString = encodeURIComponent(JSON.stringify(filter));
      return `users?${queryString}&filter=${filterString}`;
    },
    getRenewingThisMonthDownloadUrl() {
      const params = {
        order: 'Users.id',
        download: true,
      };

      const filter = {
        'users.active': true,
        paid_subscriptions: 1,
        'userplanrelationships.autorenew': true,
        'userplanrelationships.subscription_end_date': `${
          this.getThisMonthSubscriptionsRenewing().start
        }-${this.getThisMonthSubscriptionsRenewing().end}`,
      };

      const queryString = new URLSearchParams(params).toString();
      const filterString = encodeURIComponent(JSON.stringify(filter));
      return `users?${queryString}&filter=${filterString}`;
    },
    getPastDueSubscribersDownloadUrl() {
      const params = {
        download: true,
      };
      const queryString = new URLSearchParams(params).toString();
      return `charts/past-due-report?${queryString}`;
    },
    async getSettings() {
      this.loading = true;
      this.getData(`resources/dashboard/settings`)
        .then(({ data }) => {
          this.showStats = { ...data.display_panels };
        })
        .catch((error) => {
          console.log('get settings error', error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    async getChurnCounts(amount, time) {
      let returnValue = null;
      await this.getData(
        `charts/churn-count?date_start=${this.getSubtractedDate(amount, time)}&date_end=${
          this.getFormattedEndDate
        }`,
      )
        .then(({ data }) => {
          returnValue = data.count;
        })
        .catch((error) => {
          console.log('get churn error', error);
        });
      return returnValue;
    },

    manageUserTable(value, add = true) {
      if (add) {
        this.userTables.unshift(value);
      } else {
        this.userTables = this.userTables.filter((item) => {
          return item.index !== value.index;
        });
      }
    },
  },
  computed: {
    key() {
      return this.$store.getters['resource/currentResource']
        ? this.$store.getters['resource/currentResource'].key
        : null;
    },
    getFormattedEndDate() {
      return moment(this.currentDate)
        .hours(23)
        .minutes(59)
        .seconds(59)
        .format('YYYY-MM-DD HH:mm:ss');
    },
    userTablesOptions() {
      return {
        new_single_subscriptions_this_month: {
          title: i18n.t('dashboard.new_single_subscriptions_this_month'),
          url: `/admin/users?order=Users.id`,
          params: {
            'users.active': true,
            paid_subscriptions: true,
            new_paid_subscribers_from: this.getThisMonthSubscriptionsStart().start,
            'userplanrelationships.is_team_subscription': false,
            'userplanrelationships.created_at': `${this.getThisMonthSubscriptionsStart().start}-${
              this.getThisMonthSubscriptionsStart().end
            }`,
          },
          columnsType: 'past_due',
          loading: false,
          enableExport: true,
          exportRequest: this.getNewSingleSubscriptionsThisMonthDownloadUrl(),
          index: Symbol(),
          show: false,
        },
        new_team_subscriptions_this_month: {
          title: i18n.t('dashboard.new_team_subscriptions_this_month'),
          url: `/admin/users?order=Users.id`,
          params: {
            'users.active': true,
            'teams.count': -1,
            'userplanrelationships.subscription_start_date': `${
              this.getThisMonthSubscriptionsStart().start
            }-${this.getThisMonthSubscriptionsStart().end}`,
          },
          columnsType: 'past_due',
          loading: false,
          enableExport: true,
          exportRequest: this.getNewTeamSubscriptionsThisMonthDownloadUrl(),
          index: Symbol(),
          show: false,
        },
        downgrading_paid_member_this_month: {
          title: i18n.t('dashboard.downgrading_paid_member_this_month'),
          url: `/admin/users?order=Users.id`,
          params: {
            'users.active': true,
            paid_subscriptions: 1,
            'userplanrelationships.autorenew': false,
            'userplanrelationships.subscription_end_date': `${
              this.getThisMonthPaidExpiring().start
            }-${this.getThisMonthPaidExpiring().end}`,
          },
          columnsType: 'past_due',
          loading: false,
          enableExport: true,
          exportRequest: this.getDowngradingPaidMemberThisMonthDownloadUrl(),
          index: Symbol(),
          show: false,
        },
        renewing_this_month: {
          title: i18n.t('dashboard.renewing_this_month'),
          url: `/admin/users?order=Users.id`,
          params: {
            'users.active': true,
            paid_subscriptions: 1,
            'userplanrelationships.autorenew': true,
            'userplanrelationships.subscription_end_date': `${
              this.getThisMonthSubscriptionsRenewing().start
            }-${this.getThisMonthSubscriptionsRenewing().end}`,
          },
          columnsType: 'past_due',
          loading: false,
          enableExport: true,
          exportRequest: this.getRenewingThisMonthDownloadUrl(),
          index: Symbol(),
          show: false,
        },
        past_due_users: {
          title: i18n.t('dashboard.past_due_users'),
          url: '/admin/charts/past-due-report',
          columnsType: 'past_due',
          loading: false,
          enableExport: true,
          exportRequest: this.getPastDueSubscribersDownloadUrl(),
          index: Symbol(),
          show: false,
        },
        churnWW: {
          title: i18n.t('dashboard.churn_w_w'),
          url: this.getChurnQuery(1, 'week'),
          columnsType: 'churn',
          loading: false,
          enableExport: true,
          exportRequest: `charts/${this.getChurnQuery(1, 'week', false)}&download=true`,
          index: Symbol(),
          show: false,
        },
        churnMM: {
          title: i18n.t('dashboard.churn_m_m'),
          url: this.getChurnQuery(1, 'month'),
          columnsType: 'churn',
          loading: false,
          enableExport: true,
          exportRequest: `charts/${this.getChurnQuery(1, 'month', false)}&download=true`,
          index: Symbol(),
          show: false,
        },
        churnYY: {
          title: i18n.t('dashboard.churn_y_y'),
          url: this.getChurnQuery(1, 'year'),
          columnsType: 'churn',
          loading: false,
          enableExport: true,
          exportRequest: `charts/${this.getChurnQuery(1, 'year', false)}&download=true`,
          index: Symbol(),
          show: false,
        },
      };
    },
    groupBy() {
      return this.statisticsParams ? this.statisticsParams.group_by : 'day';
    },
  },
  watch: {
    key() {
      this.loading = true;
      this.clearArrays();
      this.getSettings();
      this.getCharts();
    },
  },
};
</script>
